
// import '../changePassword/changePassword.css'
// import React, { useContext, useState ,useEffect } from 'react'
// import { AppContext } from '../../App'
// import { ToastContainer, toast } from 'react-toastify';
// import 'react-toastify/dist/ReactToastify.css';
// import Side from '../side/Side';

// const Transfer = () => {
//     const [clientId,setClientId]=useState("")
//     const [price,setPrice]=useState("")
//     const [password,setPassword]=useState("")
//     const {route,setLoader}=useContext(AppContext)
//     const [user,setUser]=useState({})
//     const [name,setName]=useState("")
//     const calc =()=>{
//       setLoader(true)
//       fetch(`${route}/market/calculateTotalProfits`,{
//         method:"PUT" ,
//         headers :{
//           "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//         }
//       })
//       .then(res=>res.json())
//       .then(data =>{
//         setLoader(false)
//         console.log(data)
//         if(data.status === "success"){
//           window.location.reload();
//           toast.success(data.msg)
          
//         }
//         else if (data.status === "failed"){
//           toast.error(data.msg)
//         }
//       })
//     }
//     const handleSubmit = async (event) => {
//         event.preventDefault();
//         setLoader(true)
//         try {
//           const response = await fetch(`${route}/acc/transferePoints`, {
//             method: 'PUT',
//             headers:{
//                 'Content-Type': 'application/json',
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             },
//             body: JSON.stringify({
//                 reciever_id : clientId, 
//                 bocketPassword :password,
//                 amount : price
//             })
//           })
//           .then(res=>res.json())
//           console.log(response)
//           setLoader(false)
//           if(response.status === 'success'){
//             toast.success(response.msg)
//           }
//         if(response.status === "faild" || response.status === "failed"){
// toast.error(response.msg)
//         }
  
    
         
//         } catch (error) {
//           console.error(error);
        
//         }
//       };

//       const changeId =(e)=>{
//         setClientId(e.target.value)
//         fetch(`${route}/getUserName/${e.target.value}`)
//         .then(res=>res.json())
//         .then(data=>{console.log(data)
//         if(data.name){
// setName(data.name)
//         }
//         })
//       }

//       useEffect(()=>{
//         fetch(`${route}/acc/getMe`,{
//             headers:{
//                 "Authorization" :`Bearer ${sessionStorage.getItem("token")}`
//             }
//         })
//         .then(res=>res.json())
//         .then(data=>{
//             console.log(data)
//             setUser(data.user)
//         })
       
//     },[])

//   return (
//  <div className="transfer">
//        <div className="container">
//             <h2>تحويل رصيد</h2>
//             <h2>{user.total_points} الرصيد المتاح</h2>
//             <form action="" onSubmit={handleSubmit} >
//                 <input onChange={changeId} type="text" placeholder='العميل المراد التحويل له' />
//                 <input onChange={(e)=>setPrice(e.target.value)} type="text"placeholder='المبلغ' />
//                 <input onChange={(e)=>setPassword(e.target.value)} type="text" placeholder='كلمة سر الخزنة'/>
//                 {/* {name ?: null} */}
//                 <div>{name}</div> 
//                 <button type='submit'>ارسال</button>

//             </form>
           
//         </div>
//         <Side />
//  </div>
//   )
// }

// export default Transfer


import './transfer.scss'
import React, { useContext, useState, useEffect } from 'react'
import { AppContext } from '../../App'
import { toast } from 'react-toastify'
import Side from '../side/Side'

const Transfer = () => {
  const [clientId, setClientId] = useState("")
  const [price, setPrice] = useState("")
  const [password, setPassword] = useState("")
  const { route, setLoader } = useContext(AppContext)
  const [user, setUser] = useState({})
  const [name, setName] = useState("")

  const handleSubmit = async (event) => {
    event.preventDefault()
    setLoader(true)

    try {
      const response = await fetch(`${route}/acc/transferePoints`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          "Authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        body: JSON.stringify({
          reciever_id: clientId,
          bocketPassword: password,
          amount: price
        })
      }).then(res => res.json())

      setLoader(false)

      if (response.status === 'success') {
        toast.success(response.msg)
      } else {
        toast.error(response.msg)
      }

    } catch (error) {
      setLoader(false)
      console.error(error)
    }
  }

  const changeId = (e) => {
    const value = e.target.value
    setClientId(value)

    fetch(`${route}/getUserName/${value}`)
      .then(res => res.json())
      .then(data => {
        if (data.name) {
          setName(data.name)
        } else {
          setName("")
        }
      })
  }

  useEffect(() => {
    fetch(`${route}/acc/getMe`, {
      headers: {
        "Authorization": `Bearer ${sessionStorage.getItem("token")}`
      }
    })
      .then(res => res.json())
      .then(data => {
        setUser(data.user)
      })
  }, [])

  return (
    <div className="transfer-page">
      <div className="transfer-container">
        <h2>تحويل رصيد</h2>

        <div className="balance-card">
          الرصيد المتاح:
          <span>{user.total_points}</span>
        </div>

        <form className="transfer-form" onSubmit={handleSubmit}>
          <div className="field">
            <label>رقم / كود العميل</label>
            <input
              type="text"
              onChange={changeId}
              placeholder="أدخل كود العميل"
            />
          </div>

          {name && (
            <div className="receiver-name">
              المستلم: <span>{name}</span>
            </div>
          )}

          <div className="field">
            <label>المبلغ</label>
            <input
              type="number"
              onChange={(e) => setPrice(e.target.value)}
              placeholder="أدخل المبلغ"
            />
          </div>

          <div className="field">
            <label>كلمة سر الخزنة</label>
            <input
              type="password"
              onChange={(e) => setPassword(e.target.value)}
              placeholder="أدخل كلمة السر"
            />
          </div>

          <button className="submit-btn" type="submit">
            إرسال التحويل
          </button>
        </form>
      </div>

      <Side />
    </div>
  )
}

export default Transfer
